<form
  class="bg-surface-background p-6 text-support-text sm:p-8"
  (ngSubmit)="confirm()"
>
  <div class="mb-5">
    <p class="page-section-kicker">Account access</p>
    <h2
      class="font-spaceGrotesk text-[26px] font-semibold text-inverted-neutral"
    >
      Deactivate this account?
    </h2>
    <p class="mt-3 inter-300 text-[14px] leading-6">
      This will deactivate
      <span class="inter-500 text-inverted-neutral">{{ data.accountName }}</span>,
      remove access, and mask account contact details. Questionnaire data,
      files, and audit records are retained. This action cannot be undone from
      the app.
    </p>
  </div>

  <label class="flex flex-col gap-2">
    <span class="inter-500 text-[14px] text-inverted-neutral">
      Enter your current password to deactivate this account.
    </span>
    <input
      type="password"
      autocomplete="current-password"
      class="form-control"
      [ngModel]="currentPassword()"
      (ngModelChange)="currentPassword.set($event)"
      name="currentPassword"
    />
  </label>

  <div class="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
    <button
      type="button"
      class="rounded-full border border-nav-btn-border bg-transparent px-5 py-2 inter-500 text-[14px] text-nav-btn-text transition-colors hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="rounded-full border border-red-secondary bg-red-primary px-5 py-2 inter-500 text-[14px] text-red-secondary transition-colors hover:bg-red-secondary hover:text-red-primary disabled:cursor-not-allowed disabled:opacity-50"
      [disabled]="!canDeactivate()"
    >
      Deactivate account
    </button>
  </div>
</form>
